export default __webpack_public_path__ + "static/media/flames.db5010f6.gif";